import type { ControllerFieldState } from 'react-hook-form';
import { forwardRef } from 'react';

import { usePanelContentsSubscribe } from '../../components/Panels/shared/CollapsiblePanel/CollapsiblePanel.hook';
import { Checkbox, type CheckboxProps } from '../../../Toolkit/Inputs/Checkbox';

type FinanceCheckboxProps = Omit<
  CheckboxProps,
  'hasError' | 'errorMessage' | 'name'
> &
  ControllerFieldState & { name: string; isOptional?: boolean };

export const FinanceCheckbox = forwardRef<
  HTMLInputElement,
  FinanceCheckboxProps
>((props, ref) => {
  const { invalid, isOptional = false, checked, ...rest } = props;
  usePanelContentsSubscribe({
    name: props.name,
    value: checked,
    invalid,
    isOptional,
  });
  return (
    <Checkbox
      {...rest}
      hasError={invalid}
      errorMessage={props.error?.message}
      ref={ref}
      checked={checked}
    />
  );
});

FinanceCheckbox.displayName = 'FinanceCheckbox';
